import React from 'react';
import { classNames } from '../../utils/classNames';

export const Switch = ({ checked, onChange, disabled = false, id, className, 'aria-label': ariaLabel }) => (
  <button
    id={id}
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={classNames(
      'inline-flex h-6 w-11 shrink-0 items-center rounded-full border p-0.5 transition',
      checked
        ? 'justify-end border-accent/40 bg-accent'
        : 'justify-start border-border bg-slate-200 dark:bg-slate-700',
      disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
      className
    )}
  >
    <span
      className={classNames(
        'block h-4 w-4 rounded-full shadow-sm ring-1 ring-black/10 transition-transform',
        checked ? 'bg-white dark:bg-slate-100' : 'bg-white dark:bg-slate-100'
      )}
    />
  </button>
);
